import React, { useState } from 'react';
import PathIcon from '../../../assets/icon-path.svg?react';
import HourglassIcon from '../../../assets/icon-hourglass.svg?react';
import TickIcon from '../../../assets/icon-google-tick.svg?react';
import CloseIcon from '../../../assets/icon-close.svg?react';
import { Button } from 'react-bootstrap';
import DeleteModal from '@/components/content/DeleteModal';

type IconState = 'idle' | 'loading' | 'success';

interface FileUploadBadgeProps {
  uploadedFileTitle: string;
  knowledgeFileId?: string;
  iconState?: IconState;
  statusText?: string;
  fileStatus?: boolean;
  loadingFile?: boolean;
  showRemoveButton?: boolean;
  onRemove?: (idOrTitle: string) => void;
}

const resolveIconState = (props: FileUploadBadgeProps): IconState => {
  if (props.iconState) return props.iconState;
  if (props.loadingFile || props.fileStatus) return 'loading';
  return 'idle';
};

const FileUploadBadge: React.FC<FileUploadBadgeProps> = (props) => {
  const {
    uploadedFileTitle,
    knowledgeFileId,
    statusText,
    showRemoveButton = true,
    onRemove,
  } = props;

  const iconState = resolveIconState(props);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const handleFileRemove = () => {
    if (knowledgeFileId) {
      setShowDeletePopup(true);
    } else {
      onRemove?.(uploadedFileTitle);
    }
  };

  const renderIcon = () => {
    if (iconState === 'loading') {
      return <HourglassIcon data-testid="sync-hourglass-icon" />;
    }
    if (iconState === 'success') {
      return <TickIcon className="tickIcon" data-testid="sync-tick-icon" />;
    }
    if (showRemoveButton) {
      return (
        <Button
          variant="link"
          className="remove-file-btn"
          onClick={handleFileRemove}
          aria-label="Remove file"
        >
          <CloseIcon className="closeIcon" data-testid="sync-close-button" />
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="uploaded-file-container" data-testid="uploaded-file-container">
      <div className="uploaded-file-preview">
        <div data-testid="sync-file-icon">
          <PathIcon />
        </div>
        <div className="file-info">
          <div className="file-info-text">
            <p title={uploadedFileTitle} data-testid="sync-file-title">
              {uploadedFileTitle}
            </p>
            {statusText && <p data-testid="sync-file-status">{statusText}</p>}
          </div>
          <div className="uploadedfile-icon-container">{renderIcon()}</div>
        </div>

        {showDeletePopup && onRemove && knowledgeFileId && (
          <DeleteModal
            showDeletePopup={showDeletePopup}
            setShowDeletePopup={setShowDeletePopup}
            deleteSourceById={(id?: string) => {
              if (id) onRemove(id);
            }}
            documentId={knowledgeFileId}
            deleteIconVisible={true}
          />
        )}
      </div>
    </div>
  );
};

export default FileUploadBadge;
